import { observer } from "mobx-react-lite";
import { useApp } from "../../../context";
import { Box, Card, CircularProgress, Typography } from "@material-ui/core";
import { AnalyticCategoryQuestions } from "./CategoryQuestions";

export const AnalyticQuestions = observer(function AnalyticQuestions() {
  const app = useApp();
  const questions = app.benchmarks.questions;

  if (!questions.length) {
    return (
      <Card style={{ padding: 40 }}>
        <Box display="flex" flexDirection="column" alignItems="center" style={{ gap: 16 }}>
          <CircularProgress />
          <Typography variant="body2" color="textSecondary">Fragen werden geladen...</Typography>
        </Box>
      </Card>
    );
  }

  return (
    <Card style={{ padding: 24, overflow: "visible" }}>
      <AnalyticCategoryQuestions questions={questions} />
    </Card>
  );
});
